import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { StyledFlex } from '../../../styles/common';
import { spacing } from '../../../styles/theme';
export const StyledTransactionDetail = styled(StyledFlex) `
  -webkit-text-size-adjust: 100%;
  margin-bottom: ${spacing.base}px;

  &:last-of-type {
    margin-bottom: 0;
  }

  > dt {
    // Width needed to maintain fixed column
    @media ${mediaQueries.greaterThanMedium} {
      flex-basis: 270px;
    }
  }

  > dd {
    margin-left: ${spacing.large}px;

    @media ${mediaQueries.greaterThanMedium} {
      margin-left: ${spacing.small}px;
    }
  }

  .svg-inline--fa.fa-dollar-sign {
    // Align dollar sign icon with other icons
    margin-left: ${spacing.xsmall}px;
  }
`;
export const StyledTransactionDetailValue = styled(StyledFlex) `
  text-align: right;
`;
//# sourceMappingURL=subcomponents.js.map